export default __webpack_public_path__ + "static/media/Deepiq_chart (6).9ba41242.png";